// frontend/src/components/ZonePopup.js
import React from 'react';

function ZonePopup({ zone, onClose, onUnlock, codeWord, setCodeWord, isUnlocked }) {
  return (
    <div className="popup-overlay">
      <div className="zone-popup">
        <button className="close-button" onClick={onClose}>×</button>
        <h2 style={{ marginTop: 0 }}>{zone.name}</h2>
        
        {isUnlocked ? (
          <>
            <div className="status unlocked">Пройдено ✓</div>
            <div className="history-info">
              <h3>Историческая справка:</h3>
              <p>{zone.history}</p>
            </div>
          </>
        ) : (
          <>
            <div className="status locked">Не пройдено</div>
            <div className="hint-info">
              <h3>Подсказка:</h3>
              <p>{zone.hint}</p>
            </div>
            
            <div className="unlock-form" style={{ display: 'flex', gap: 8, marginTop: 12 }}>
              <input
                type="text"
                value={codeWord}
                onChange={(e) => setCodeWord(e.target.value)}
                placeholder="Введите кодовое слово"
                autoFocus
                inputMode="text"
                style={{ flex: 1, padding: 10, fontSize: 16, borderRadius: 8, border: '1px solid #ddd' }}
              />
              <button onClick={onUnlock} style={{ padding: '10px 14px', fontSize: 16, borderRadius: 8 }}>
                Разблокировать
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ZonePopup;